import React, { memo, useCallback, useState } from 'react'
import clsx from 'clsx'
import { Popover } from '@mantine/core'
import styled from '@emotion/styled'
import { css } from '@emotion/css'
import tw from 'twin.macro'
import { SolidStarIcon, StarIcon } from '@ow/icons'
import useAppListStore from './appListStore'
import ModifyModal from './modifyModal'
import { ICON_MAP } from './config/icon'

const Star = ({ active, onClick }) => {
  return (
    <div
      className={css`
        position: absolute;
        left: 7px;
        top: 7px;
        &:hover {
          opacity: 0.7;
        }
      `}
      onClick={(e) => {
        e.stopPropagation()
        onClick(!active)
      }}
    >
      {!active ? (
        <StarIcon width={16} height={16} fill="#d27f33" />
      ) : (
        <SolidStarIcon width={16} height={16} fill="#d27f33" />
      )}
    </div>
  )
}

const Tag = styled.span`
  position: absolute;
  top: 10px;
  right: 8px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 9px;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  padding-left: 6px;
  padding-right: 6px;
  user-select: none;
`

const PoverInfoLine = styled.p`
  line-height: 20px;
  word-break: break-all;
`

const Info = ({ data }) => {
  const [opened, setOpened] = useState(false)
  return (
    <Popover
      className="overflow-hidden"
      opened={opened}
      onClose={() => setOpened(false)}
      position="bottom"
      placement="start"
      withArrow
      trapFocus={false}
      closeOnEscape={false}
      transition="pop-top-left"
      width={260}
    >
      <Popover.Target>
        <div
          className="flex-1 overflow-hidden"
          onMouseEnter={() => setOpened(true)}
          onMouseLeave={() => setOpened(false)}
        >
          <div className="truncate text-sm">{data.title}</div>
          <div
            className={css`
              color: rgba(0, 0, 0, 0.45);
              margin-top: 2px;
              ${tw`text-xs`}
            `}
          >
            {data.createdAt.slice(0, 10)}
          </div>
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <div className="text-xs" style={{ margin: -4 }}>
          <PoverInfoLine>项目ID：{data.id}</PoverInfoLine>
          <PoverInfoLine>项目名称：{data.title}</PoverInfoLine>
          <PoverInfoLine>创建时间：{data.createdAt}</PoverInfoLine>
        </div>
      </Popover.Dropdown>
    </Popover>
  )
}

export const Menu = ({ data }) => {
  const [opened, setOpened] = useState(false)
  const setState = useAppListStore((state) => state.setState)
  const onClose = useCallback(() => setOpened(false), [])
  return (
    <Popover
      opened={opened}
      onClose={onClose}
      position="bottom"
      placement="start"
      transition="pop-top-right"
    >
      <Popover.Target>
        <div
          className={clsx(
            css`
              color: #444444;
              &:hover {
                background-color: rgba(0, 0, 0, 0.05);
              }
            `,
            'hover-visible',
            'rounded h-6 w-6 text-center select-none flex-shrink-0',
            !opened && 'hidden'
          )}
          onClick={() => {
            setState({ appId: data.id })
            setOpened(!opened)
          }}
        >
          ···
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <ModifyModal data={data} onClose={onClose} />
      </Popover.Dropdown>
    </Popover>
  )
}

const AppStatus = ({ data }) => {
  if (data.isDeleted) return <Tag>已删除</Tag>

  if (data.status === 0) return <Tag>未发布</Tag>

  return null
}

const CardItem = ({ data, itemClickHandler }) => {
  const [star, setStar] = useState(data.star)
  const setAppStar = useAppListStore((state) => state.setAppStar)
  const onStar = useCallback(
    async (v) => {
      setStar(v)
      if (!(await setAppStar(data.id, v))) {
        setStar(!v)
      }
    },
    [data]
  )

  const Icon = ICON_MAP[data.iconId || 0]
  return (
    <div
      className={css`
        transition: all 0.3s ease-in-out;
        &:hover {
          box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.15);
          .hover-visible {
            display: block;
          }
        }
        ${tw`w-48 rounded-lg border cursor-pointer`}
      `}
      onClick={() => {
        itemClickHandler(data)
      }}
    >
      <div
        className={css`
          height: 6.75rem;
          ${tw`flex justify-center items-center relative`}
        `}
      >
        <Icon size={40} color={data.color} />
        <Star active={star} onClick={onStar} />
        <AppStatus data={data} />
      </div>
      <div
        className={css`
          height: 3.5rem;
          background-color: #f7f9fb;
          ${tw`flex gap-3 items-center justify-between px-4`}
        `}
      >
        <Info data={data} />
        {/* <Menu data={data} /> */}
      </div>
    </div>
  )
}

export default memo(CardItem)
